import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import StickyCTA from "./components/StickyCTA";
import Home from "./pages/Home";
import Solutions from "./pages/Solutions";
import PathScore from "./pages/PathScore";
import AreaScore from "./pages/AreaScore";
import Industries from "./pages/Industries";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import BlogAdmin from "./pages/BlogAdmin";
import TalentAdmin from "./pages/TalentAdmin";
import TalentNetwork from "./pages/TalentNetwork";
import TalentPrivacy from "./pages/TalentPrivacy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StickyCTA />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<Solutions />} />

            {/* Canonical product routes */}
            <Route path="/path-score" element={<PathScore />} />
            <Route path="/area-score" element={<AreaScore />} />

            {/* Legacy IQ / Score redirects (permanent, back to canonical) */}
            <Route path="/route-iq"    element={<Navigate to="/path-score" replace />} />
            <Route path="/routeiq"     element={<Navigate to="/path-score" replace />} />
            <Route path="/route-score" element={<Navigate to="/path-score" replace />} />
            <Route path="/routescore"  element={<Navigate to="/path-score" replace />} />
            <Route path="/site-iq"     element={<Navigate to="/area-score" replace />} />
            <Route path="/siteiq"      element={<Navigate to="/area-score" replace />} />
            <Route path="/site-score"  element={<Navigate to="/area-score" replace />} />
            <Route path="/sitescore"   element={<Navigate to="/area-score" replace />} />

            <Route path="/industries" element={<Industries />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/score-a-corridor" element={<Contact variant="corridor" />} />
            <Route path="/start-your-project" element={<Contact />} />

            <Route path="/insights" element={<Blog />} />
            <Route path="/insights/:slug" element={<BlogPost />} />
            <Route path="/blog" element={<Navigate to="/insights" replace />} />
            <Route path="/blog/:slug" element={<RedirectBlogSlug />} />

            <Route path="/talent-network" element={<TalentNetwork />} />
            <Route path="/talent-pool" element={<Navigate to="/talent-network" replace />} />
            <Route path="/talent-network/privacy" element={<TalentPrivacy />} />

            <Route path="/right-of-way" element={<Navigate to="/solutions" replace />} />
            <Route path="/right-of-way-acquisition-texas" element={<Navigate to="/solutions" replace />} />
            <Route path="/title-research" element={<Navigate to="/solutions" replace />} />
            <Route path="/gis-mapping" element={<Navigate to="/solutions" replace />} />
            <Route path="/renewable-energy-land" element={<Navigate to="/industries" replace />} />
            <Route path="/survey" element={<Navigate to="/solutions" replace />} />
          </Route>

          <Route path="/admin/blog" element={<BlogAdmin />} />
          <Route path="/admin/talent-network" element={<TalentAdmin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

// Client-side redirect: /blog/:slug → /insights/:slug (preserves the slug)
const RedirectBlogSlug = () => {
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const slug = path.replace(/^\/blog\//, "");
  return <Navigate to={`/insights/${slug}`} replace />;
};

export default App;
